import React, { useContext } from 'react'
import { Table, Col, Input, Button, Row, Card, Popover, Divider, Popconfirm } from 'antd'
import SearchOutlined from '@ant-design/icons/lib/icons/SearchOutlined'
import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'
import { Context, useStore } from '../../../context'

const { Search } = Input

function FelTable(props) {
  const [state] = useContext(Context)
  const { hasPermissions } = useStore(state)

  const columns = [
    {
      title: 'Empresa',
      dataIndex: 'company_name', // Field that is goint to be rendered
      key: 'company_name',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Tienda',
      dataIndex: 'store_name', // Field that is goint to be rendered
      key: 'store_name',
      render: text => <span>{text}</span>,
    },
    {
      title: 'RTN',
      dataIndex: 'rtn', // Field that is goint to be rendered
      key: 'rtn',
      render: text => <span>{text}</span>,
    },
    {
      title: 'CAI',
      dataIndex: 'cai', // Field that is goint to be rendered
      key: 'cai',
      render: text => <span>{text}</span>,
    },
    {
      title: 'Fecha limite',
      dataIndex: 'emission_limit_date', // Field that is goint to be rendered
      key: 'emission_limit_date',
      render: text => <span>{text}</span>,
    },    
    {
      title: 'Dirección',
      dataIndex: 'address', // Field that is goint to be rendered
      key: 'address',
      render: text => <span>{text}</span>,
    },
    {
      title: '',
      dataIndex: 'id', // Field that is goint to be rendered
      key: 'id',
      render: (row, data) => (
        <span>
          {
            <Popover
              placement="left"
              style={{ zIndex: 'auto' }}
              content={
                <div>
                  {hasPermissions([87]) && (
                    <span className={'user-options-items'} onClick={() => handlerEditRow(data)}>
                      Editar
                    </span>
                  )}
                  {hasPermissions([87, 88]) && <Divider className={'divider-enterprise-margins'} type={'horizontal'} />}
                  {hasPermissions([88]) && (
                    <Popconfirm
                      title="¿Estás seguro de eliminar el elemento selccionado?"
                      onConfirm={() => handlerDeleteRow(data)}
                      okText="Sí"
                      cancelText="No"
                    >
                      <span className={'user-options-items'}>Eliminar</span>
                    </Popconfirm>
                  )}
                </div>
              }
              trigger="click"
            >
              {(hasPermissions([3]) || hasPermissions([4])) && (
                <Button shape={'circle'} className={'enterprise-settings-button'}>
                  <MoreOutlined />
                </Button>
              )}
            </Popover>
          }
        </span>
      ),
    },
  ]
  
  const getFilteredData = data => {
    props.handlerTextSearch(data)
  }

  const handlerEditRow = row => {    
    props.handlerEditRow(row)
  }

  const handlerDeleteRow = row => {
    props.handlerDeleteRow(row)
  }

  return (
    <>
      <Row>
        <Col xs={18} sm={18} md={18} lg={18}>
          <Search
            prefix={<SearchOutlined className={'tendero-table-search-icon'} />}
            placeholder="Presiona enter para buscar"
            className={'tendero-table-search custom-search'}
            size={'large'}
            onSearch={e => getFilteredData(e)}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Card className={'card-border-radius margin-top-15'}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Table
                  className={'CustomTableClass'}
                  dataSource={props.dataSource}
                  columns={columns}
                  pagination={false}
                  loading={props.loading}
                  rowKey="key"                  
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default FelTable
